export const shiftTypeColorMap: Record<string, "warning" | "info" | "primary"> = {
  am: "warning",
  pm: "info",
  noc: "primary",
};
